var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',[_c('h1',[_vm._v("403")]),_vm._v(" "),_c('h2',[_vm._v("Unauthorized")])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"editorial"},[_c('p',[_vm._v("It looks like you don't have the appropriate permissions to perform this action.")])])])])
}]

export { render, staticRenderFns }